<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>
    <div class="flex" style="min-height: 250px;">
      <div class="w-full">
        <v-wait for="senders">
          <half-circle-spinner
            style="display: block; margin: 80px auto 0"
            :animation-duration="1000"
            :size="60"
            color="var(--brand-primary)"
            slot="waiting"
          />
          <div class="flex">
            <vertical-tabs
              :tabs="navTabs"
              :currentTab="navSettingTab"
              :wrapper-class="'pt-5 w-44 border-r border-grey-200 pb-10'"
              @onClick="handleNavTabChange"
            />
            <div class="p-5 w-full relative">
              <div>
                <div
                  v-if="this.navSettingTab === 'sender'"
                  class="w-full flex flex-col relative"
                >
                  <div
                    id="groovemail-client-table-views"
                    class="mt-4 groovemail-table-common groovemail-email-sender-tables relative table-space-small"
                    v-if="senders.length"
                  >
                    <div class="w-full new-add-btn-wrapper">
                      <div class="flex justify-between items-center">
                        <p class="text-deep-dark text-2xl font-bold">
                          {{ $t('frontend_groovemail_settings_sender_settings') }}
                        </p>
                        <gd-button
                          primary
                          @click="openCreateSetting"
                          class="w-40 h-10 new-add-btn"
                          >{{
                            $t('frontend_groovemail_segment_new_sender')
                          }}</gd-button
                        >
                      </div>
                    </div>
                    <v-client-table
                      ref="sendersTable"
                      :data="senders"
                      :columns="SettingTableColumns"
                      :options="SettingTableOptions"
                    >
                      <div slot="gateway" slot-scope="props">
                        <p>
                          {{ getDriver(props.row.driver) }}
                        </p>
                      </div>
                      <div slot="is_verified" slot-scope="props">
                        <p>
                          {{ props.row.is_verified == 1 ? 'Yes' : 'No' }}
                        </p>
                      </div>

                      <div slot="is_default" slot-scope="props">
                        <p>
                          {{ props.row.is_default == 1 ? 'Yes' : 'No' }}
                        </p>
                      </div>

                      <div slot="actions" slot-scope="props">
                        <dropdown-button class="float-right pr-4">
                          <span
                            slot="link"
                            class="bg-white h-10 flex items-center inline-block font-medium pl-3 pr-2 py-1 border border-grey-200 rounded"
                          >
                            <span class="mr-3 pr-2 font-medium">{{
                              $t(
                                'frontend_groovemail_settings_integeration_listing_actions'
                              )
                            }}</span>
                            <svg
                              class="h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </span>
                          <div
                            slot="dropdown"
                            class="bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer" :style="props.row.is_verified != 1 ? 'width:150px' : ''"
                          >
                            <!-- Can mail/Upgraded user/Sandbox mode check -->
                            <div
                              v-if="!(userCanMail == 0)"
                              class="no-underline block p-2 text-md font-normal bg-white"
                              @click="openEditSetting(props.row.id)"
                            >
                              {{ $t('frontend_edit') }}
                            </div>

                            <!-- Can mail/Upgraded user/Sandbox mode check -->
                            <div
                              v-if="
                                props.row.driver === 2 || props.row.driver === 3 || props.row.driver === 4 || props.row.driver === 5
                              "
                              class="no-underline block p-2 text-md font-normal bg-white"
                              @click="showWebhookUrl(props.row)"
                            >
                              {{
                                $t(
                                  'frontend_groovemail_senders_smtp_get_webhook_url_action'
                                )
                              }}
                            </div>
                            <div
                              v-if="!(userCanMail == 0) && (props.row.is_verified!=1)"
                              class="no-underline block p-2 text-md font-normal bg-white" 
                              
                              @click="resendVerificationMail(props.row.id)"
                            >
                              {{ $t('frontend_groovemail_sender_listing_reverification') }}
                            </div>
                            <div
                              class="no-underline block p-2 text-md font-normal bg-white"
                              @click="deleteSetting(props.row.id)"
                            >
                              {{ $t('frontend_delete') }}
                            </div>
                          </div>
                        </dropdown-button>
                      </div>
                    </v-client-table>
                  </div>
                  <div v-else class="flex justify-center my-5">
                    <empty-listing-state
                      :empty_state_heading="'frontend_groovemail_sender_title'"
                      :empty_state_sub_heading="'frontend_groovemail_settings_sender_dont_have_sender'"
                      :empty_state_button_text="'frontend_groovemail_segment_new_sender'"
                      @executeDataCreation="openCreateSetting"
                    ></empty-listing-state>
                  </div>
                </div>
                <div
                  v-if="this.navSettingTab === 'integeration'"
                  class="w-full flex flex-col relative sms-sender-settings"
                >
                  <div
                    id="groovemail-client-table-views"
                    class="mt-4 groovemail-table-common relative groovemail-sms-sender-tables table-space-small"
                    v-if="integerations.length"
                  >
                    <div
                      class="w-full flex justify-between items-center new-add-btn-wrapper"
                    >
                      <p class="text-deep-dark text-2xl font-bold">
                        {{
                          $t('frontend_groovemail_settings_integeration_settings')
                        }}
                      </p>
                      <gd-button
                        variant="primary"
                        @click="addIntegeration"
                        class="w-40 h-10 new-add-btn"
                        >{{
                          $t('frontend_groovemail_segment_new_sender')
                        }}</gd-button
                      >
                    </div>
                    <v-client-table
                      :key="integerationTableKey"
                      ref="integerationsTable"
                      :data="integerations"
                      :columns="integerationSettingTableColumns"
                      :options="integerationSettingTableOptions"
                    >
                      <div slot="phone_number" slot-scope="props">
                        <p class="">
                          {{
                            props.row.country_code + ' ' + props.row.from_number
                          }}
                        </p>
                      </div>

                      <div slot="is_default" slot-scope="props">
                        <p class="">
                          {{
                            props.row.is_default == 1
                              ? $t('frontend_yes_I_am_sure')
                              : $t('frontend_no')
                          }}
                        </p>
                      </div>

                      <div slot="actions" slot-scope="props">
                        <dropdown-button class="float-right pr-2">
                          <span
                            slot="link"
                            class="bg-white h-10 flex items-center inline-block font-medium pl-3 pr-2 py-1 border border-grey-200 rounded"
                          >
                            <span class="mr-3 pr-2 font-medium">{{
                              $t(
                                'frontend_groovemail_settings_integeration_listing_actions'
                              )
                            }}</span>
                            <svg
                              class="h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </span>
                          <div
                            slot="dropdown"
                            class="bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer"
                          >
                            <!-- Can mail/Upgraded user/Sandbox mode check -->
                            <div
                              v-if="!(userCanMail == 0)"
                              class="no-underline block p-2 text-grey-darkest bg-white"
                              @click="editIntegeration(props.row.id)"
                            >
                              {{ $t('frontend_edit') }}
                            </div>
                            <!-- Can mail/Upgraded user/Sandbox mode check -->
                            <div
                              class="no-underline block p-2 text-grey-darkest bg-white"
                              @click="removeIntegeration(props.row.id)"
                            >
                              {{ $t('frontend_delete') }}
                            </div>
                          </div>
                        </dropdown-button>
                      </div>
                    </v-client-table>
                  </div>
                  <div v-else class="flex justify-center my-5">
                    <empty-listing-state
                      :empty_state_heading="'frontend_groovemail_sender_title'"
                      :empty_state_sub_heading="'frontend_groovemail_settings_integeration_dont_have_integeration'"
                      :empty_state_button_text="'frontend_groovemail_segment_new_sender'"
                      @executeDataCreation="addIntegeration"
                    ></empty-listing-state>
                  </div>
                </div>
              
                <div
                  v-if="this.navSettingTab === 'recipients'"
                  class="w-full flex flex-col relative"
                >
                  <div
                    id="groovemail-server-table-views"
                    class="mt-4 groovemail-table-common relative groovemail-recipient-tables table-space-small"
                  >
                    <div
                      class="w-full flex justify-between items-center new-add-btn-wrapper"
                    >
                      <p class="text-deep-dark text-2xl font-bold">
                        {{
                          $t('frontend_groovemail_settings_recipients_settings')
                        }}
                      </p>
                      <gd-button
                        variant="primary"
                        @click="showRecipientModal"
                        class="w-40 h-10 new-add-btn"
                        >{{
                          $t('frontend_groovemail_settings_recipients_add_new_recipient')
                        }}</gd-button
                      >
                    </div>
                    <v-server-table
                      ref="recipientsTable"
                      url="/recipient"
                      :key="recipientsTableKey"
                      :columns="recipientsSettingTableColumns"
                      :options="recipientsSettingTableOptions"
                      class="text-center"
                      @loaded="loadedTable()"
                      @loading="loadingTable()"
                    >
                      <div slot="updated_at" slot-scope="props">
                        <p>
                          <span>{{
                            props.row.updated_at
                              ? `${new Date(props.row.updated_at).getDate()} ${
                                  months[new Date(props.row.updated_at).getMonth()]
                                }, ${new Date(props.row.updated_at).getFullYear()}`
                              : $t('frontend_groovemail_not_available')
                          }}</span>
                        </p>
                      </div>
                      
                      <div slot="actions" slot-scope="props">
                        <dropdown-button class="float-right pr-2">
                          <span
                            slot="link"
                            class="bg-white h-10 flex items-center inline-block font-medium pl-3 pr-2 py-1 border border-grey-200 rounded"
                          >
                            <span class="mr-3 pr-2 font-medium">{{
                              $t(
                                'frontend_groovemail_settings_integeration_listing_actions'
                              )
                            }}</span>
                            <svg
                              class="h-4 w-4"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                            >
                              <path
                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                              />
                            </svg>
                          </span>
                          <div
                            slot="dropdown"
                            class="bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer"
                          >
                            <div
                              class="no-underline block p-2 text-grey-darkest bg-white"
                              @click="removeRecipient(props.row.id)"
                            >
                              {{ $t('frontend_delete') }}
                            </div>
                          </div>
                        </dropdown-button>
                      </div>
                    </v-server-table>
                  </div>
                </div>
                <gd-modal name="create-sender-modal" width="800px" :title="senderModalTitle">
                  <div class="scroll-modal">
                    <create-sender :btnValue="btnValue" :senderId="senderId" @fetchSender="fetchEmailSenders" />
                  </div>
                </gd-modal>
                <gd-modal name="create-integeration-modal" width="800px" :title="integerationModalTitle">
                  <div class="scroll-modal">
                    <create-integeration :btnValue="btnValue" :senderId="senderId" @fetchSender="fetchSmsSenders" />
                  </div>
                </gd-modal>
              </div>
            </div>
          </div>
        </v-wait>

        <gd-modal
          class="custom-modal"
          id="webhook-url-modal"
          name="webhook-url-modal"
          :title="
            this.$t('frontend_groovemail_senders_webhook_url') + ' ' + 
            this.$t('frontend_groovemail_senders_webhook_selected_events')  
          "
        >
          <div class="p-6">
            <div class="flex">
              <text-input
                v-model="webhookUrl"
                value="webhookUrl"
                :disabled="true"
                :placeholder="this.$t('frontend_product_step8_webhook')"
              />
            </div>
            <div class="flex justify-end mt-6">
              <gd-button
                class="h-10 btn-width px-4 btn-radius text-base font-semibold border-grey-300"
                size="auto"
                @click="closeWebhookUrlModal"
                >{{ $t('frontend_cancel') }}</gd-button
              >
              <gd-button
                v-clipboard:copy="webhookUrl"
                v-clipboard:success="onCopyWeebhookUrl"
                v-clipboard:error="onErrorWebhookUrl"
                class="h-10 btn-width px-4 btn-radius text-base font-semibold border-grey-300 ml-2"
                variant="primary"
                size="auto"
              >
                {{ $t('frontend_copy') }}
              </gd-button>
            </div>
          </div>
        </gd-modal>

        <gd-modal
          class="custom-modal"
          id="add-recipient-modal"
          name="add-recipient-modal"
          :title="
            this.$t('frontend_groovemail_settings_recipients_add_new_recipient') 
          "
          @closed="addRecipientModalClosed()"
        >
          <div class="p-6">
            <div class="flex flex-col mb-6">
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_settings_recipients_label_recipient') }}
              </label>
              <text-input
                class="text-dark text-sm"
                :validator="$v.model.email"
                :attribute="
                  this.$t('frontend_groovemail_settings_recipients_label_recipient')
                "
                :disabled="otpFieldActive"
                v-model="model.email"
                value="model.email"
                :placeholder="
                  this.$t('frontend_groovemail_settings_recipients_enter_recipient')
                "
              />
            </div>

            <div
              class="flex flex-col mb-6"
              v-show="otpFieldActive"
            >
              <label class="font-semibold text-sm text-grey-700 mb-2">
                {{ $t('frontend_groovemail_import_leads_process_email_verification_otp_attribute') }}
              </label>
              <text-input
                class="text-dark text-sm"
                :validator="$v.model.otp"
                :attribute="
                  this.$t('frontend_groovemail_import_leads_process_email_verification_otp_attribute')
                "
                v-model="model.otp"
                value="model.otp"
                :placeholder="
                  this.$t('frontend_groovemail_import_leads_process_email_verification_enter_otp')
                "
              />
            </div>
            
            <div class="flex justify-end mt-6">
              <gd-button
                class="h-10 btn-width px-4 btn-radius text-base font-semibold border-grey-300"
                size="auto"
                @click="closeRecipientModal"
                >
                  {{ $t('frontend_cancel') }}
              </gd-button>
              <gd-button
                class="h-10 btn-width px-4 btn-radius text-base font-semibold border-grey-300 ml-2"
                :variant="!otpFieldActive ? 'primary' : 'base'"
                size="auto"
                @click="sendOTP"
              >
                {{ otpFieldActive? $t('frontend_groovemail_settings_recipients_resend_otp') :  $t('frontend_groovemail_settings_recipients_send_otp')}}
              </gd-button>
              <gd-button
                class="h-10 btn-width px-4 btn-radius text-base font-semibold border-grey-300 ml-2"
                variant="primary"
                v-show="otpFieldActive"
                size="auto"
                @click="saveRecipient"
              >
                {{ $t('frontend_save') }}
              </gd-button>
            </div>
          </div>
        </gd-modal>

        <gd-modal
          class="custom-modal"
          id="senders-detail-modal"
          name="senders-detail-modal"
          :title="this.$t('frontend_groovemail_campains_step2_sender')"
        >
          <div class="p-6">
            <div class="flex relative">
              <div class="flex justify-center mb-5 w-full">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x=".5" y=".5" width="39" height="39" rx="5.5" fill="#FFDEE4" stroke="#EA3D5E"/>
                  <path d="m15 15 10 10M25 15 15 25" stroke="#EA3D5E" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="absolute right-0 cursor-pointer" 
                @click="closeSenderDetailModal"
              >
                <CloseIcon/>
              </div>
            </div>
            <VuePerfectScrollbar 
              class="overflow-scroll"
              style="max-height: calc(-250px + 100vh);"
            >
              <div class="text-center" v-html="senderLinkedModulesTemplate"></div>
            </VuePerfectScrollbar>
            <div class="flex text-center">
              <div v-if="existingVerifiedSenders && existingVerifiedSenders.length">
                <p class="text-sm font-bold text-deep-dark mt-6">
                  {{ 
                    this.$t('frontend_groovemail_senders_deletion_have_verified_senders')
                  }}
                </p>
                <div v-if="existingVerifiedSendersType === 'email'" class="flex justify-center mt-4">
                  <treeselect
                    :key="1"
                    class="custom-singlelevel-select w-1/2 sender-tree-select"
                    v-model="senderChoosenToSwitch"
                    :closeOnSelect="closeOnSelect"
                    :clearable="clearable"
                    :clearOnSelect="clearOnSelect"
                    :openDirection="openDirection"
                    :multiple="false"
                    :options="verifiedEmailSenderList"
                    :placeholder="this.$t('frontend_groovemail_sequences_email_select_sender')"
                  />
                </div>
                <div v-if="existingVerifiedSendersType === 'sms'" class="flex justify-center mt-4">
                  <treeselect
                    :key="2"
                    class="custom-singlelevel-select w-1/2 sender-tree-select"
                    v-model="senderChoosenToSwitch"
                    :closeOnSelect="closeOnSelect"
                    :clearable="clearable"
                    :clearOnSelect="clearOnSelect"
                    :multiple="false"
                    :openDirection="openDirection"
                    :options="verifiedSmsSenderList"
                    :placeholder="this.$t('frontend_groovemail_sequences_email_select_sender')"
                  />
                </div>
                <div
                  class="text-sm text-danger mt-2"
                  v-if="this.senderSwitchInitiated && !senderChoosenToSwitch"
                >
                  {{
                    this.$t(
                      'frontend_groovemail_campaigns_create_select_sender_to_proceed'
                    )
                  }}
                </div>
              </div>
              <div v-else>
                <p class="text-sm font-bold text-deep-dark mt-6">
                  {{ 
                    this.$t('frontend_groovemail_senders_deletion_do_not_have_verified_senders')
                  }}
                </p>
              </div>
            </div>
            <div class="flex justify-center mt-6">
              <gd-button
                class="h-10 delete-sender-btn btn-width px-4 btn-radius text-base font-semibold border-grey-300"
                size="auto"
                v-if="existingVerifiedSenders && existingVerifiedSenders.length"
                @click="switchAndDeleteSender"
              >
                {{ $t('frontend_delete') }}
              </gd-button>
              <gd-button
                class="h-10 close-sender-modal-btn btn-width px-4 btn-radius text-base font-semibold border-grey-300 ml-2"
                variant="primary"
                size="auto"
                @click="closeSenderDetailModal"
              >
                {{ $t('frontend_close') }}</gd-button
              >
            </div>
          </div>
        </gd-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { email, maxLength, minLength, numeric, required } from 'vuelidate/lib/validators';
// import { mapGetters } from 'vuex';

import Notify from '../../../notify';
import Treeselect from '@riophae/vue-treeselect';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EmptyListingState from './components/empty-listing-state.vue';
import Sender from './models/Sender';
// import NavigationTabs from './components/navigation-tabs.vue';
import VerticalTabs from '../VerticalTabs';
import CloseIcon from './assets/images/icons/close-icon.svg';
import InfoIcon from './assets/images/icons/info-icon.svg';
import showAlert from './components/sweet-alert-popup.js';

import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import CreateSender from './create';
import CreateIntegeration from './create_integeration';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'User Settings' };
  },

  data() {
    return {
      openDirection: 'above',
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      senderLinkedModulesTemplate: '',
      existingVerifiedSenders: [],
      senderChoosenToSwitch: null,
      existingVerifiedSender: null,
      existingVerifiedSendersType: '',
      senderSwitchInitiated: false,
      webhookUrl: '',
      showSenderWithSmtpBanner: false,
      senderTableKey: 1,
      integerationTableKey: 2,
      recipientsTableKey: 3,
      senders: [],
      model: {
        email: '',
        otp: '',
      },
      otpFieldActive: false,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: 'var(--brand-primary)',
      navTabs: [
        {
          title: this.$t('frontend_groovemail_settings_sender_settings'),
          value: 'sender',
        },
        {
          title: this.$t('frontend_groovemail_settings_integeration_settings'),
          value: 'integeration',
        },
        {
          title: this.$t('frontend_groovemail_settings_recipients_settings'),
          value: 'recipients',
        },
      ],
      navSettingTab: 'sender',
      SettingTableColumns: [
        'name',
        'sender_name',
        'sender_email',
        'reply_email',
        'gateway',
        'is_verified',
        'is_default',
        'actions',
      ],
      SettingTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['name', 'sender_name', 'sender_email', 'reply_email'],
        filterable: ['name', 'sender_name', 'sender_email', 'reply_email'],
        headings: {
          is_verified: 'Verified',
          is_default: 'Default',
        },
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      integerations: [],
      integerationSettingTableColumns: [
        'gateway_name',
        'sid',
        'token',
        'phone_number',
        'is_default',
        'actions',
      ],
      integerationSettingTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['gateway_name'],
        filterable: ['gateway_name', 'sid', 'token', 'from_number'],
        headings: {
          gateway_name: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_settings_gateway_name'
            ),
          sid: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_settings_account_sid'
            ),
          token: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_settings_auth_token'
            ),
          phone_number: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_listing_phone_number'
            ),
          is_default: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_settings_default'
            ),
          actions: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_listing_actions'
            ),
        },
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
      },

      recipientsSettingTableColumns: [
        'email',
        'updated_at',
        'actions',
      ],
      recipientsSettingTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        rowClassCallback(myRowObject) {
          return 'hover:bg-grey-50 funnelRow';
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['email', 'updated_at'],
        filterable: ['email'],
        headings: {
          email: () =>
            this.$t(
              'frontend_email'
            ),
          updated_at: () =>
            this.$t(
              'frontend_groovemail_created_at'
            ),
          actions: () =>
            this.$t(
              'frontend_groovemail_settings_integeration_listing_actions'
            ),
        },
        requestFunction(data) {
          const self = this;
          const genericUrl = `${window.config.apiUrl.split('/api')[0]}/api`;
          return axios
            .get(`${genericUrl}/groovemail${self.url}`, {
              params: data,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          return {
            data: data.data,
            count: data.total,
          };
        },
      },
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
      showCreateSender: false,
      userCanMail: null,
      btnValue: '',
      senderId: '',
      senderModalTitle: 'Create Sender',
      integerationModalTitle: 'Create Sender',
    };
  },

  validations: {
    model: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      description: {
        required,
        minLength: minLength(3),
      },
      category: {
        required,
      },
      categoryname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      otp: {
        required,
        numeric,
        minLength: minLength(4),
        maxLength: maxLength(4),
      },
    },
  },

  components: {
    Loading,
    EmptyListingState,
    // NavigationTabs,
    InfoIcon,
    CloseIcon,
    Treeselect,
    VuePerfectScrollbar,
    VerticalTabs,
    CreateSender,
    CreateIntegeration,
  },

  methods: {
    // ...mapGetters('mailing', ['getCanMail']),

    loadingTable() {
      this.showLoader();
    },

    loadedTable() {
      this.hideLoader();
    },

    async fetchEmailSenders() {
      this.senders = await Sender.$get();
    },

    async fetchSmsSenders() {
      const integerationData = await axios.get(`${this.genericUrl}/groovemail/sms-sender`);
      this.integerations = integerationData.data;
    },

    onCopyWeebhookUrl() {
      Notify.success(
        this.$t('frontend_groovemail_senders_webhook_url_copy_success')
      );
    },

    onErrorWebhookUrl() {
      Notify.fail(
        this.$t('frontend_groovemail_senders_webhook_url_copy_error')
      );
    },

    showWebhookUrl(senderData) {
      this.getWebhookUrl(senderData);
      this.$root.$emit('modal-open', 'webhook-url-modal');
    },

    closeWebhookUrlModal() {
      this.$root.$emit('modal-close', 'webhook-url-modal');
    },

    getWebhookUrl(senderData) {
      const smtpDriver = senderData.driver;
      switch (smtpDriver) {
        case 2:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-mailgun-webhook/${this.$store.state.user.id}`;
          break;
        case 3:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-sendgrid-webhook/${this.$store.state.user.id}`;
          break;
        case 4:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-sparkpost-webhook/${this.$store.state.user.id}`;
          break;
        case 5:
          this.webhookUrl = `https://v1.gdapis.com/api/groovemail/handle-ses-webhook/${this.$store.state.user.id}`;
          break;
        default:
          this.webhookUrl = '';
      }
    },

    closeSenderWithSmtpBanner() {
      this.showSenderWithSmtpBanner = false;
    },

    showRecipientModal() {
      // Can mail/Upgraded user/Sandbox mode check
      if (this.userCanMail) {
        this.$root.$emit('modal-open', 'add-recipient-modal');
      } else {
        this.showErrorForMailing();
      }
      // Can mail/Upgraded user/Sandbox mode check
    },

    closeRecipientModal() {
      this.$root.$emit('modal-close', 'add-recipient-modal');
      this.addRecipientModalClosed();
    },

    addRecipientModalClosed(){
      this.model.email='';
      this.model.otp='';
      this.$v.model.email.$reset();
      this.$v.model.otp.$reset();
      this.otpFieldActive = false;
    },

    async showAlertPopUp(error){
      await showAlert({
        iconType: 'alert-error',
        html : `<p class="text-sm text-deep-dark"> ${ error }</p>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: '#fd6481',
        confirmButtonText: this.$t(
          'frontend_close'
        ),
      });
    },

    async sendOTP(){
      this.$v.model.email.$touch();
      if(!this.$v.model.email.$invalid) {
        if (
          (this.model.email).trim().toLowerCase() ===
            (this.$store.state.user.email).trim().toLowerCase()
          ) {
            this.showAlertPopUp(this.$t('frontend_groovemail_recipients_adding_current_acc_email_warning'));
        } else {
          this.showLoader();
          try {
            const response = await axios.post(`${this.genericUrl}/groovemail/recipient/recipient-email-verification-send`, {
              "email": (this.model.email).trim().toLowerCase()
            });
            if(response.data.error) {
              this.closeRecipientModal();
              this.showAlertPopUp(response.data.message);
            } else {
              this.otpFieldActive = true;
            }
          } catch(err) {
            this.hideLoader();
          }
          this.hideLoader();
        }
      }    
    },

    async saveRecipient() {
      this.$v.model.email.$touch();
      this.$v.model.otp.$touch();
      if(!this.$v.model.email.$invalid && 
          !this.$v.model.otp.$invalid){
        this.showLoader();
        const response = await axios.post(`${this.genericUrl}/groovemail/recipient`, {
          "email": (this.model.email).trim().toLowerCase(),
          "otp": this.model.otp
          });
        this.closeRecipientModal();
        this.hideLoader();

        if (response.data.error) {
          this.showAlertPopUp(response.data.message);
        } else {
          this.$refs.recipientsTable.refresh();
          this.model.email = '';
          this.model.otp = '';
        }
      }
    },

    async removeRecipient(RecipientId) {
      const remove = await showAlert({
        iconType: 'alert-question',
        html : `<p class="text-lg font-bold text-deep-dark mb-3"> ${ this.$t('frontend_bouses_delete_bonus_title') }</p>
          <p class="text-sm text-deep-dark"> ${ this.$t('frontend_bouses_delete_bonus_text') }</p>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#2f80ed',
        cancelButtonColor: '#fd6481',
        cancelButtonText: this.$t('frontend_cancel'),
        confirmButtonText: this.$t(
          'frontend_groovemail_frontend_confirm'
        ),
      });
      if (remove) {
        this.showLoader();
        const response = await axios.delete(`${this.genericUrl}/groovemail/recipient/${RecipientId}`);
        this.hideLoader();
        
        if (response.data.error) {
          this.showAlertPopUp(response.data.error);
        } else {
          this.$refs.recipientsTable.refresh();
        }
      } 
    },

    addIntegeration() {
      // Can mail/Upgraded user/Sandbox mode check
      if (this.userCanMail) {
        this.$root.$emit('modal-open', 'create-integeration-modal');
      } else {
        this.showErrorForMailing();
      }
      // Can mail/Upgraded user/Sandbox mode check
    },

    // Can mail/Upgraded user/Sandbox mode check
    showErrorForMailing() {
      showAlert({
        iconType: 'alert-error',
        html : `<p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_is_now_open_in_beta_mode') }</p>`,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: '#fd6481',
        confirmButtonText: this.$t(
          'frontend_close'
        ),
      });
    },
    // Can mail/Upgraded user/Sandbox mode check

    async removeIntegeration(integerationId) {
      const remove = await showAlert({
        iconType: 'alert-question',
        html : `<p class="text-lg font-bold text-deep-dark mb-3"> ${ this.$t('frontend_bouses_delete_bonus_title') }</p>
          <p class="text-sm text-deep-dark"> ${ this.$t('frontend_bouses_delete_bonus_text') }</p>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#2f80ed',
        cancelButtonColor: '#fd6481',
        cancelButtonText: this.$t('frontend_cancel'),
        confirmButtonText: this.$t(
          'frontend_groovemail_frontend_confirm'
        ),
      });
      if (remove) {
        this.showLoader();
        const response = await axios.delete(`${this.genericUrl}/groovemail/sms-sender/${integerationId}`);
        this.hideLoader();
        if (response.data.error) {
          this.senderLinkedModulesTemplate = this.sendersLinkedModules(response.data.data);
          if (response.data.data.verified_senders && response.data.data.verified_senders.length) {
            this.existingVerifiedSenders = response.data.data.verified_senders;
          } else {
            this.existingVerifiedSenders = [];
          }
          this.senderChoosenToSwitch = null;
          this.existingVerifiedSendersType = 'sms';
          this.senderSwitchInitiated = false;
          this.existingVerifiedSender = integerationId;
          this.$root.$emit('modal-open', 'senders-detail-modal');
        } else {
          this.showLoader();
          await this.fetchSmsSenders();
          this.hideLoader();
        }
      }
    },

    editIntegeration(id) {
      this.btnValue = 'EditIntegeration';
      this.senderId = id;
      this.integerationModalTitle = "Edit Sender";
      // Can mail/Upgraded user/Sandbox mode check
      if (this.userCanMail) {
        this.$root.$emit('modal-open', 'create-integeration-modal');
      } else {
        this.showErrorForMailing();
      }
      // Can mail/Upgraded user/Sandbox mode check
    },

    openCreateSetting() {
      this.btnValue = 'NewSender';
      // Can mail/Upgraded user/Sandbox mode check
      if (this.userCanMail) {
        this.$root.$emit('modal-open', 'create-sender-modal');
      } else {
        this.showErrorForMailing();
      }
      // Can mail/Upgraded user/Sandbox mode check
    },
    openEditSetting(id) {
       this.btnValue = 'EditSender';
       this.senderId = id;
       this.senderModalTitle = "Edit Sender";
      // Can mail/Upgraded user/Sandbox mode check
      if (this.userCanMail) {
        this.$root.$emit('modal-open', 'create-sender-modal');
      } else {
        this.showErrorForMailing();
      }
      // Can mail/Upgraded user/Sandbox mode check
    },
    sendersLinkedModules(data) {
      let senderDetailTemplate = `<p class="text-lg font-bold text-deep-dark mb-3"> ${ this.$t('frontend_groovemail_senders_deletion_swal_heading_text') }</p>
        <p class="text-sm text-deep-dark mb-6"> ${ this.$t('frontend_groovemail_senders_deletion_swal_subheading_text') }</p>`;

      if (data.campaigns && data.campaigns.length > 0 && !(data.campaigns.every(element => element === null))) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold mb-4">${ this.$t('frontend_groovemail_broadcasts_route_page_title') }: <span class="font-normal">${  data.campaigns.join(', ')}</span></p>`;
      }
      if (data.forms && data.forms.length > 0 && !(data.forms.every(element => element === null))) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold mb-4">${ this.$t('frontend_groovemail_forms_route_page_title') }: <span class="font-normal">${  data.forms.join(', ')}</span></p>`;
      }
      if (data.sequences && data.sequences.length > 0 && !(data.sequences.every(element => element === null))) {
        senderDetailTemplate += `<p class="text-sm text-deep-dark font-bold">${ this.$t('frontend_groovemail_sequences_route_page_title') }: <span class="font-normal">${  data.sequences.join(', ')}</span></p>`;
      }
      return senderDetailTemplate;
    },

    async deleteSetting(id) {
      const remove = await showAlert({
        iconType: 'alert-question',
        html : `<p class="text-lg font-bold text-deep-dark mb-3"> ${ this.$t('frontend_bouses_delete_bonus_title') }</p>
          <p class="text-sm text-deep-dark"> ${ this.$t('frontend_groovemail_swal_revert_message') }</p>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#2f80ed',
        cancelButtonColor: '#fd6481',
        cancelButtonText: this.$t('frontend_cancel'),
        confirmButtonText: this.$t(
          'frontend_groovemail_frontend_confirm'
        ),
      });
      if (remove) {
        this.showLoader();
        const deleteResponse = await axios.delete(`${this.genericUrl}/groovemail/sender/${id}`);
        if (
          deleteResponse &&
          deleteResponse.data &&
          deleteResponse.data.error
        ) {
          this.hideLoader();
          this.senderLinkedModulesTemplate = this.sendersLinkedModules(deleteResponse.data.data);
          if (deleteResponse.data.data.verified_senders && deleteResponse.data.data.verified_senders.length) {
            this.existingVerifiedSenders = deleteResponse.data.data.verified_senders;
          } else {
            this.existingVerifiedSenders = [];
          }
          this.senderChoosenToSwitch = null;
          this.existingVerifiedSendersType = 'email';
          this.senderSwitchInitiated = false;
          this.existingVerifiedSender = id;
          this.$root.$emit('modal-open', 'senders-detail-modal');
        } else if (
          deleteResponse &&
          deleteResponse.data &&
          deleteResponse.data.message
        ) {
          await this.fetchEmailSenders();
          this.hideLoader();
        }
      }
    },

    closeSenderDetailModal() {
      this.$root.$emit('modal-close', 'senders-detail-modal');
    },

    async switchAndDeleteSender() {
      this.senderSwitchInitiated = true;
      if (this.senderChoosenToSwitch) {
        if (this.existingVerifiedSendersType === 'email') {
          await this.switchAndDeleteAnySender('sender');
          this.showLoader();
          try {
            await this.fetchEmailSenders();
            this.hideLoader();
          } catch (error) {
            this.hideLoader();
          }
        } else if (this.existingVerifiedSendersType === 'sms') {
          await this.switchAndDeleteAnySender('sms-sender');
          this.showLoader();
          try {
            await this.fetchSmsSenders();
            this.hideLoader();
          } catch (error) {
            this.hideLoader();
          }
        }
      }
    },

    async switchAndDeleteAnySender(url) {
      this.showLoader();
      try {
        const delPayload = { replace_sender_id : this.senderChoosenToSwitch };
        const response = await axios.delete(`${this.genericUrl}/groovemail/${url}/${this.existingVerifiedSender}`, { data: delPayload });
        if (
          response &&
          response.data &&
          response.data.message
        ) {
          this.$root.$emit('modal-close', 'senders-detail-modal');
        }
        this.hideLoader();
        return response;
      } catch (error) {
        this.hideLoader();
        return error;
      }
    },

    async resendVerificationMail(id){
      this.showLoader();
      try {
        const resp = await axios.get(`${this.genericUrl}/groovemail/sender/email-reverification/${id}`);
        this.hideLoader();
        if (resp.data.status === 200) {
          Notify.success(resp.data.message);
        } else if (resp.data.status === 403) {
          Notify.fail(this.$t('frontend_groovemail_senders_resend_verification_mail_after_10_min_message'));
        } else if (resp.data.status === 406) {
          Notify.fail(this.$t('frontend_groovemail_senders_resend_verification_mail_1_month_time_expired'));
        }
      } catch (e) {
        this.hideLoader();
      }
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    getDriver(driver) {
      switch (driver) {
        case 1:
          return 'GrooveMail SMTP';
        case 2:
          return 'MailGun';
        case 3:
          return 'SendGrid';
        case 4:
          return 'SparkPost';
        case 5:
          return 'Amazon-SES';
        default:
          return 'N/A';
      }
    },
    handleNavTabChange(newTab) {
      this.navSettingTab = newTab;
    },
  },

  async created() {
    const dashboardData = await axios.get(`${this.genericUrl}/groovemail/dashboard`);
    this.userCanMail = dashboardData.data.can_mail;
    this.$wait.start('senders');
    await this.fetchEmailSenders();
    if (!(this.senders && this.senders.length)) {
      this.showSenderWithSmtpBanner = true;
      if (this.showSenderWithSmtpBanner && this.userCanMail) {
        Notify.fail(
          this.$t(
            'frontend_groovemail_email_sender_please_select_smtp_driver_warning'
          )
        );
      }
    }
    await this.fetchSmsSenders();
    this.$wait.end('senders');
  },

  computed: {
    admin() {
      return this.$store.state.user.admin;
    },

    verifiedEmailSenderList() {
      const senderList = [];
      if (this.existingVerifiedSenders && this.existingVerifiedSenders.length) {
        this.existingVerifiedSenders.forEach((element) => {
          senderList.push({ id: element.id, label: element.name });
        });
      }
      return senderList;
    },

    verifiedSmsSenderList() {
      const senderList = [];
      if (this.existingVerifiedSenders && this.existingVerifiedSenders.length) {
        this.existingVerifiedSenders.forEach((element) => {
          senderList.push({ id: element.id, label: element.gateway_name });
        });
      }
      return senderList;
    },
    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },
  },
};
</script>

<style lang="scss">
#groovemail-client-table-views,
#groovemail-server-table-views {
  .new-add-btn {
    font-weight: 600;
    border-radius: 6px;
    font-size: 16px;
  }

  .new-add-btn-wrapper {
    z-index: 9;
    right: 0;
    top: 70px;
  }

  .VueTables__heading {
    color: #191d3a;
  }

  .VueTables__child-row-toggler--closed::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 7l-.707031.707031 6.125 6.125 1.875 1.875 1.875-1.875 6.125-6.125-.707031-.707031-6.125 6.125-1.167969 1.167969-1.167969-1.167969-6.125-6.125' /></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__child-row {
    text-align: center;
    border-bottom: 1px solid #ddd;
    border-left: 5px solid var(--brand-primary, #fd6481);
  }

  .VueTables__child-row-toggler--open::before {
    content: url("data:image/svg+xml; utf8, <svg width='20' height='20' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='m3.707031 1044.3622l-.707031-.707 6.125-6.125 1.875001-1.875 1.875 1.875 6.125 6.125-.707032.707-6.125-6.125-1.167968-1.168-1.167969 1.168-6.125 6.125' transform='translate(0-1030.3622)'/></svg>");
    padding-right: 3px;
    vertical-align: middle;
  }

  .VueTables__table {
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #dcdcea;
    width: 100%;
    padding: 0px;
    background: white;
    border-radius: 6px;
    box-shadow: 20px 20px 40px rgba(22, 29, 37, 0.05);
  }

  tr:nth-child(even) {
    background: #f8f8fc;
  }

  .vue-pagination-ad {
    text-align: center;
  }

  .VuePagination__count {
    display: none;
  }

  .expandIcon {
    display: none;
  }

  .funnelRow:hover .expandIcon {
    display: block !important;
  }

  tr.VueTables__child-row > td {
    padding: 0px !important;
  }

  .VueTables__table th:last-child span {
    display: none;
  }

  .VueTables__row:last-child {
    border-bottom: none;
  }
  &.table-space-small .VueTables__table {
    th, td {
      &:first-child {
        padding-left: 25px;
      }
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

#groovemail-client-table-views {
  .VueTables--client table {
    th:nth-child(1),
    td:nth-child(1) {
      padding-left: 35px;
    }
  }

  .VueTables--client {
    border: 0px !important;
  }

  .VueTables__search-field input:focus {
    outline: none;
  }

  .VueTables__search-field label {
    display: none;
  }

  // .VueTables--client .table-responsive {
  //   background: #efeff5;
  // }

  .VuePagination {
    float: right;
  }

  .VueTables__search-field {
    margin-bottom: 80px;
  }

  .VueTables__sort-icon {
    color: #191d3a;
    margin-left: 8px;
  }

  .VueTables__table th {
    text-align: left;
    padding: 25px 12px;
    font-size: 14px;
    border-bottom: 2px solid #dcdcea;
    .pull-right {
      float: none;
    }
  }

  .VueTables__table td {
    text-align: left;
    padding: 16px;
    font-size: 14px;
    color: #2d3540;
    font-weight: 600;
    .pull-right {
      float: none;
    }
  }

  .pagination li:disabled,
  .pagination li.disabled {
    color: #8f92ab;
    cursor: not-allowed;
  }

  .pagination li:disabled a,
  .pagination li.disabled a {
    cursor: not-allowed;
  }

  .VueTables__search__input.form-control {
    height: 40px;
    width: 328px;
    padding: 6px 12px 6px 35px;
    font-size: 14px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #dcdcea;
    border-radius: 4px;
    margin: 10px 10px 0px 10px;
  }

  .VueTables__search-field {
    position: relative;
  }

  .VueTables__search-field:before {
    width: 24px;
    height: 24px;
    content: '';
    display: inline-block;
    position: absolute;
    left: 17px;
    top: 18px;
    background-image: url('./assets/images/icons/search_query.png');
  }

  label {
    font-weight: bold;
    margin: 0 10px;
    margin: 10px 10px 0px 10px;
  }

  .pull-left.VueTables__search {
    float: right;
    input {
      margin-right: 0px;
    }
  }

  .VueTables__limit {
    display: block;
  }
}

#groovemail-server-table-views {
  // .VueTables--server .table-responsive {
  //   background: #efeff5;
  // }

  .VueTables__sort-icon {
    float: none;
    color: #191d3a;
    margin-left: 8px;
  }

  .VueTables__table {
    border: 1px solid #dcdcea;
  }

  .VueTables__table td {
    text-align: left;
    padding: 16px;
    font-size: 14px;
    color: #2d3540;
    font-weight: 600;
    .pull-right {
      float: none;
    }
  }

  .VueTables__table th {
    text-align: left;
    padding: 25px 12px;
    font-size: 14px;
    border-bottom: 2px solid #dcdcea;
    .pull-right {
      float: none;
    }
  }

  th:nth-child(1),
  td:nth-child(1) {
    padding-left: 35px;
  }

  .VueTables__search {
    float: right;
    .VueTables__search-field {
      margin-bottom: 80px;
      position: relative;
      label {
        display: none;
      }
    }

    .VueTables__search-field .VueTables__search__input {
      height: 40px;
      width: 328px;
      padding: 6px 12px 6px 35px;
      font-size: 14px;
      color: #555;
      background-color: #fff;
      background-image: none;
      border: 1px solid #dcdcea;
      border-radius: 4px;
      margin: 10px 0px 0px 10px;
    }

    .VueTables__search-field:before {
      width: 24px;
      height: 24px;
      content: '';
      display: inline-block;
      position: absolute;
      left: 17px;
      top: 18px;
      background-image: url('./assets/images/icons/search_query.png');
    }
  }

  label {
    font-weight: bold;
    margin: 0 10px;
    margin: 10px 10px 0px 10px;
  }

  .VueTables__limit {
    display: block;
  }
}

.groovemail-table-common {
  .pagination li,
  .VuePagination__pagination li {
    float: left;
    font-size: 14px;
    text-align: center;
    color: #191d3a;
    padding: 4px;
    font-weight: 600;
    margin-left: 4px;
    line-height: 1.25;
  }

  .VueTables__limit {
    margin-top: 10px;
    position: absolute;
    bottom: -60px;
    left: 0;
    .VueTables__limit-field {
      label {
        display: none;
      }
      &:before {
        content: 'Show';
        display: inline-block;
        color: #69788c;
        font-size: 12px;
        margin-right: 10px;
        font-weight: 600;
      }
      &:after {
        width: 11px;
        height: 7px;
        display: inline-block;
        content: '';
        background-image: url('./assets/images/icons/down-icon.png');
        position: absolute;
        right: 12px;
        top: 15px;
        pointer-events: none;
      }
      select {
        border: 1px solid #dcdcea;
        border-radius: 6px;
        height: 40px;
        width: 80px;
        background: #fff;
        padding: 0 28px 0 8px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
      }
    }
  }

  .VueTables--server .VueTables__limit {
    margin-bottom: 20px;
    bottom: -30px;
    .VueTables__limit-field {
      display: flex;
      align-items: center;
    }
  }

  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-prev-page,
  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-next-page {
    cursor: pointer;
  }

  .VuePagination.row.col-md-12.justify-content-center {
    margin-top: 30px;
  }

  .pagination {
    margin-top: 30px;
    float: right;
    display: block !important;
  }

  .VuePagination__pagination-item {
    border: none;
    background-color: transparent;
    color: #191d3a;
  }

  .VuePagination__pagination-item .active,
  .VuePagination__pagination .paginationActive,
  .page-item.active {
    border-radius: 6px;
    background-color: var(--brand-primary, #fd6481);
    color: var(--brand-primary-invert, #ffffff);
  }

  .pagination li a,
  .VuePagination__pagination li a,
  .pagination li a.active,
  .VuePagination__pagination li a.active {
    padding: 3px 4px;
  }

  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-prev-chunk,
  .VuePagination__pagination-item.paginationPrev.VuePagination__pagination-item-prev-chunk,
  .VuePagination__pagination-item.page-item.VuePagination__pagination-item-next-chunk,
  .VuePagination__pagination-item.paginationNext.VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination {
    .VuePagination__pagination {
      display: flex !important;
    }
  }

  .VuePagination__pagination-item.paginationPrev,
  .VuePagination__pagination-item.paginationNext {
    background: transparent;
  }

  .VuePagination {
    .paginationPrev,
    .paginationNext {
      cursor: pointer;
    }
  }

  .VuePagination {
    .paginationPrev.paginationDisabled,
    .paginationNext.paginationDisabled {
      color: #8f92ab;
      cursor: not-allowed;
    }
  }
}

.groovemail-settings-tabs {
  .settings-tabs-inner {
    border-radius: 6px 6px 0px 0px;
  }
  z-index: 9;
  top: 0px;
}

.top-170 {
  top: 170px;
}

.groovemail-email-sender-tables {
  .VueTables--client table {
    overflow: auto !important;
    th:nth-child(1),
    td:nth-child(1),
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3),
    th:nth-child(4),
    td:nth-child(4) {
      width: 18%;
      word-break: break-word;
    }
  }
}

.groovemail-email-sender-tables,
.groovemail-sms-sender-tables,
.groovemail-recipient-tables {
  .VueTables__table{
    overflow: auto !important;
  }
  // .VueTables__table th {
  //   padding-top: 35px !important;
  // }
  .VueTables__search-field {
    margin-bottom: 15px !important;
  }
  .VueTables__limit {
    bottom: -5px !important;
  }
}

.groovemail-recipient-tables {
  .VueTables--server table{
    margin-bottom: 50px;
  }
}

.mail_settings_tab_head {
  button {
    margin-right: 8px;
    padding: 16px;
    outline: none;
    span {
      outline: none;
    }
  }
  button:focus {
    outline: none;
  }
}

.sms-sender-phone-input {
  color: #8689a4;
}

.gm-nav-senders-tabs {
  top: 45px;
  z-index: 10;
}

#senders-detail-modal {
  .border-solid.border-b.border-grey-200.h-16.w-full.flex.flex-row {
    display: none;
  }
  .close-sender-modal-btn {
    background: var(--brand-primary, #fd6481) !important;
  }
  .delete-sender-btn {
    background: #2f80ed !important;
    color: #ffffff !important;
    border-color: #2f80ed !important;
  }
}

.sender-tree-select {
  .vue-treeselect__menu {
    border: 1px solid #dcdcea !important;
  }
  .vue-treeselect__option.vue-treeselect__option--highlight:hover {
    background: #efeff5 !important;
  }
}
.scroll-modal {
  max-height: calc(100vh - 100px) !important;
  overflow: auto;
}
.sms-sender-settings {
  #groovemail-client-table-views .VueTables--client table, 
  #groovemail-client-table-views .VueTables--client table {
    th {
      white-space: nowrap;
    }
    th, td {
      word-break: break-all;
      &:first-child {
        min-width: 170px;
      }
      &:nth-child(4) {
        min-width: 170px;
      }
      &:last-child {
        white-space: nowrap;
      }
    }
  }
}
</style>
